module.exports = __webpack_public_path__ + "img/ihvoronezh.jpg?9cf411ff5852c9fadeaae27ce07570f0";